<template>
  <div class="bc-report-management">
    <type-container title="体检事实">
      <pagination-table
        v-for="table in typeTables"
        :key="table.key"
        :title="table.source.title"
        :table-data="table.source.entities"
        :table-props="table.source.props"
        :total="table.source.total"
        :loading="table.source.loading"
        :page-index="table.source.pageIndex"
        :page-size="table.source.pageSize"
        :show-total="table.source.showTotal"
        :is-question="table.source.isQuestion"
        :is-page-hand="table.source.pageHand"
        @pageChanged="tablePageChanged($event, table)"
      />
    </type-container>
    <report-analysis
      type="management"
      kind="analysis"
    />
    <report-analysis
      type="management"
      kind="suggestion"
    />
  </div>
</template>

<script>
import TypeContainer from '@/components/report/ReportTypeContainer'
import PaginationTable from '@/components/table/PaginationTable'
import ReportAnalysis from './ReportAnalysis'
import mixin from '@/mixins/lawExamReport'
import lawExamProps from '@/service/law-exam/props'
export default {
  name: 'BcReportManagement',
  components: { PaginationTable, ReportAnalysis, TypeContainer },
  mixins: [ mixin ],
  props: {
    enterpriseId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      abnormal: { ...lawExamProps.abnormal },
      punishment: { ...lawExamProps.punishment },
      equity: { ...lawExamProps.equity },
      mortgage: { ...lawExamProps.mortgage },
      ownTax: { ...lawExamProps.ownTax },
      illegal: { ...lawExamProps.illegal },
      license: { ...lawExamProps.license },
      certificate: { ...lawExamProps.certificate }
    }
  },
  computed: {
    // 经营异常 abnormal
    // 行政处罚 punishment
    // 股权质押 equity
    // 动产抵押 mortgage
    // 欠税公告 ownTax
    // 严重违法 illegal
    // 行政许可证 license
    // 业务资质 certificate
    typeTables () {
      return [
        { key: 'queryQA', source: this.queryQA },
        { key: 'abnormal', source: this.abnormal },
        { key: 'punishment', source: this.punishment },
        { key: 'equity', source: this.equity },
        { key: 'mortgage', source: this.mortgage },
        { key: 'ownTax', source: this.ownTax },
        { key: 'illegal', source: this.illegal },
        { key: 'license', source: this.license },
        { key: 'certificate', source: this.certificate }
      ]
    }
  },
  created () {
    this.queryQA.type = 2
  }
}
</script>
